<ion-toolbar class="content-width" [hidden]="!venue()?.courts?.length">
  <ion-item detail="false" lines="none">
    <ion-select
      label="{{'Actions' | translate}}"
      value="INTEGRATIONS"
      #courtAction
      label-placement="stacked"
      interface="popover"
      (ionChange)="onCourtActionChange(courtAction.value)"
    >
      <ion-select-option value="INTEGRATIONS">{{'Integrations' | translate}}</ion-select-option>
      <ion-select-option value="EDIT">{{'Edit Court' | translate}}</ion-select-option>
      <ion-select-option value="DELETE">{{'Delete Courts' | translate}}</ion-select-option>
    </ion-select>
  </ion-item>
</ion-toolbar>

<form [formGroup]="courtsListForm">
  <ion-list class="content-width">
    <ion-radio-group
      (ionChange)="openUpdateModel($event.target.value)"
      formControlName="courts"
    >
      @if (venue()?.courts?.length) { @for (court of venue().courts; let i =
      $index; track i) {
      <ion-item>
        @if (courtAction.value === 'INTEGRATIONS') {
        <ion-label>
          {{ court.courtName }}
          @if (court.surfaceType) {
          <ion-text color="gray" class="ion-text-wrap">
            <p>{{ court.surfaceType }}</p>
          </ion-text>
          }
        </ion-label>
        <ion-chip
          slot="end"
          color="secondary"
          (click)="openVideoBoardModal(court)"
        >
          <ion-icon name="tv"></ion-icon>
          <ion-label>{{ court.videoBoards?.length || "0" }}</ion-label>
        </ion-chip>

        <ion-chip
          slot="end"
          color="secondary"
          (click)="openIntegrationModal(court)"
        >
          <ion-icon name="videocam"></ion-icon>
          <ion-label>{{ court.devices?.length || "0" }}</ion-label>
        </ion-chip>
        } @else if (courtAction.value === 'EDIT') {
        <ion-radio
          [checked]="isCourtChecked(court._id)"
          (ionChange)="selectCourts($event, court._id)"
          justify="space-between"
          [value]="court._id"
        >
          {{ court.courtName }}
        </ion-radio>
        } @else if (courtAction.value === 'DELETE') {
        <ion-checkbox
          [checked]="isCourtChecked(court._id)"
          (ionChange)="selectCourts($event, court._id)"
          justify="space-between"
        >
          {{ court.courtName }}
        </ion-checkbox>
        }
      </ion-item>
      } } @else {
      <ion-item color="none">
        <div class="ion-text-center ion-margin">
          <ion-text color="gray">
            {{'This venue does not have any courts' | translate}}
          </ion-text>
        </div>
      </ion-item>
      }

      <ion-button
        class="ion-margin"
        (click)="isCourtModalOpen = true"
        expand="block"
        fill="clear"
        color="primary"
      >
        {{'Add courts' | translate}}
      </ion-button>

      @if (selectedCourts.length && courtAction.value === 'DELETE') {
      <ion-button
        class="ion-margin"
        (click)="deleteCourts()"
        expand="block"
        fill="clear"
        color="danger"
      >
        {{'Delete courts' | translate}}
      </ion-button>
      }
    </ion-radio-group>
  </ion-list>
</form>

<ion-modal
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  [isOpen]="isCourtModalOpen"
  (ionModalDidDismiss)="isCourtModalOpen = false"
>
  <ng-template>
    <div class="wrapper">
      <h3>{{'Create courts' | translate}}</h3>

      <ion-list>
        <form [formGroup]="courtForm">
          <ion-item detail="false">
            <ion-input
              type="number"
              label="{{'Number of courts' | translate}}"
              labelPlacement="stacked"
              formControlName="count"
            ></ion-input>
          </ion-item>

          <ion-item detail="false">
            <ion-input
              type="text"
              label="{{'Court name' | translate}}"
              labelPlacement="stacked"
              formControlName="courtName"
            ></ion-input>
          </ion-item>

          <ion-item detail="false">
            <ion-select
              label="{{'Surface' | translate}}"
              formControlName="surfaceType"
              label-placement="stacked"
              interface="popover"
            >
              <ion-select-option value="HARD">{{'Hard' | translate}}</ion-select-option>
              <ion-select-option value="CLAY">{{'Clay' | translate}}</ion-select-option>
              <ion-select-option value="GRASS">{{'Grass' | translate}}</ion-select-option>
            </ion-select>
          </ion-item>

          <ion-button
            (click)="createCourts()"
            expand="block"
            class="ion-margin"
          >
            {{'Submit' | translate}}
          </ion-button>
        </form>
      </ion-list>
    </div>
  </ng-template>
</ion-modal>

<ion-modal
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  [isOpen]="courtAction.value === 'EDIT' && selectedCourt !== null"
  (ionModalDidDismiss)="resetEditSelection()"
>
  <ng-template>
    <div class="wrapper">
      <h3>{{'Update court' | translate}}</h3>

      <ion-list>
        <form [formGroup]="courtUpdateForm">
          <ion-item detail="false">
            <ion-input
              type="text"
              value=""
              label="{{'Court name' | translate}}"
              labelPlacement="stacked"
              formControlName="courtName"
            ></ion-input>
          </ion-item>

          @if (courtAction.value === 'EDIT') {
          <ion-button (click)="updateCourt()" expand="block" class="ion-margin">
            {{'Submit' | translate}} </ion-button
          >}
        </form>
      </ion-list>
    </div>
  </ng-template>
</ion-modal>

<ion-modal
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  [isOpen]="courtAction.value === 'EDIT' && selectedCourt !== null"
  (ionModalDidDismiss)="resetEditSelection()"
>
  <ng-template>
    <div class="wrapper">
      <h3>{{'Update court' | translate}}</h3>

      <ion-list>
        <form [formGroup]="courtUpdateForm">
          <ion-item detail="false">
            <ion-input
              type="text"
              value=""
              label="Court name"
              labelPlacement="stacked"
              formControlName="courtName"
            ></ion-input>
          </ion-item>

          @if (courtAction.value === 'EDIT') {
          <ion-button (click)="updateCourt()" expand="block" class="ion-margin">
            {{'Submit' | translate}} </ion-button
          >}
        </form>
      </ion-list>
    </div>
  </ng-template>
</ion-modal>

<ion-modal
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  [isOpen]="isIntegrationModalOpen"
  (ionModalDidDismiss)="isIntegrationModalOpen = false"
>
  <ng-template>
    <div class="wrapper">
      <ion-item>
        <ion-text>
          <h3>{{ selectedCourtForIntegrationModal.courtName }}</h3>
          <p>Video streaming, scoreboards and line calling</p>
        </ion-text>

        <ion-button
          size="default"
          slot="end"
          expand="block"
          fill="clear"
          (click)="showAddIntegration()"
        >
          <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
      </ion-item>

      <ion-list>
        @if (!selectedCourtForIntegrationModal.devices?.length ) {
        <ion-item line="none">
          <div class="ion-text-center ion-margin">
            <ion-text color="gray">
              This court does not have any integrations
            </ion-text>
          </div>
        </ion-item>
        } @else { @for (device of selectedCourtForIntegrationModal.devices;
        track $index; let last = $last;) {
        <ion-item [lines]="last ? 'none' : null">
          {{ device.name }} ({{ device.partner }})
          <ion-button
            size="default"
            slot="end"
            color="danger"
            (click)="removeDevice(device._id)"
            fill="clear"
          >
            <ion-icon slot="icon-only" name="trash"></ion-icon>
          </ion-button>
        </ion-item>
        } }
      </ion-list>

      @if (isAddIntegrationCardOpen) {
      <ion-card>
        <ion-card-content>
          <ion-item>
            <ion-select
              #partner
              label="Device provider"
              placeholder="Select provder"
              interface="popover"
            >
              @for (integration of venue().integrations; let i = $index; track
              i) {
              <ion-select-option [value]="integration">{{
                integration.partner.username | partnerName
              }}</ion-select-option>
              }
            </ion-select>
          </ion-item>

          <ion-item>
            <ion-select
              #partnerCourt
              [disabled]="!partner.value"
              label="Select Device"
              placeholder="Select Device"
              interface="popover"
            >
              @for (camera of partner.value?.cameras; track $index) {
              <ion-select-option [value]="camera">{{
                camera.name
              }}</ion-select-option>
              }
            </ion-select>
          </ion-item>

          <ion-button
            class="ion-margin"
            [disabled]="!partnerCourt?.value"
            (click)="addDevice(partnerCourt.value)"
            expand="block"
          >
            Add Device
          </ion-button>
        </ion-card-content>
      </ion-card>
      }
    </div>
  </ng-template>
</ion-modal>

<ion-modal
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  [isOpen]="isVideoBoardModalOpen"
  (ionModalDidDismiss)="isVideoBoardModalOpen = false"
>
  <ng-template>
    <div class="wrapper">
      <ion-item>
        <ion-text>
          <h3>{{ selectedCourtForIntegrationModal.courtName }}</h3>
          <p>Custom video boards provided by iOnCourt</p>
        </ion-text>

        <ion-button
          size="default"
          slot="end"
          expand="block"
          fill="clear"
          (click)="showAddIntegration()"
        >
          <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
      </ion-item>

      @if (!selectedCourtForIntegrationModal.devices?.length ) {
      <ion-item>
        <div class="ion-text-center ion-margin">
          <ion-text color="gray">
            This court does not have any video boards
          </ion-text>
        </div>
      </ion-item>

      }

      <ion-list>
        @for (videoBoard of selectedCourtForIntegrationModal.videoBoards; track
        $index; let last = $last;) {
        <ion-item [lines]="last ? 'none' : null">
          {{ videoBoard.name }}
          <ion-button
            size="default"
            slot="end"
            color="danger"
            (click)="removeVideoBoard(videoBoard._id)"
            fill="clear"
          >
            <ion-icon slot="icon-only" name="trash"></ion-icon>
          </ion-button>
        </ion-item>
        }
      </ion-list>

      @if (isAddIntegrationCardOpen) {
      <ion-card>
        <ion-card-content>
          <ion-item>
            <ion-select
              #videoBoard
              label="Video board"
              placeholder="Select video board"
              interface="popover"
            >
              @for (videoBoard of videoBoards(); let i = $index; track i) {
              <ion-select-option [value]="videoBoard._id">{{
                videoBoard.name
              }}</ion-select-option>
              }
            </ion-select>
          </ion-item>
          <ion-button
            class="ion-margin"
            [disabled]="!videoBoard?.value"
            (click)="addVideoBoard(videoBoard.value)"
            expand="block"
          >
            Add Video Board
          </ion-button>
        </ion-card-content>
      </ion-card>
      }
    </div>
  </ng-template>
</ion-modal>
